import {useTranslation} from 'react-i18next';

type Props = {
  title: string;
  description?: string;
};

function PublicFormInfo({title, description}: Props) {
  const {t} = useTranslation();

  return (
    <div className="w-full flex flex-col gap-1 px-4 pt-4 pb-2 flex-shrink-0 bg-white">
      {/* Form Title */}
      <h1 className="m-0 text-[24px] font-bold text-linkBlue">{title}</h1>

      {/* Description — max ~12 words per line via max-width, wraps naturally */}
      {description && (
        <p className="m-0 text-[16px] text-black max-w-[480px] text-right">
          {description}
        </p>
      )}

      {/* Mandatory question legend */}
      <div className="flex items-center gap-1">
        <span className="text-raspberryRed text-[20px] font-bold">*</span>
        <span className="text-[16px] text-black">
          {t('forms.public.mandatoryLegend')}
        </span>
      </div>
    </div>
  );
}

export default PublicFormInfo;
